import React from "react";
import { useState , useEffect} from "react";
import AOS from "aos";
import "aos/dist/aos.css";


export default function UIDesign() {


  useEffect(() => {
    AOS.init({ duration: 2000, once: true });
  }, []);

  const services = [
    {
      title: "UI UX consulting",
      description:
        "Musemind helps you to navigate complex design challenges through our UI/UX consulting services. Our experienced consultants provide strategic guidance and actionable insights to optimize your digital experiences and achieve business objectives.",
      image: "https://placehold.co/300x200?text=UI+UX+consulting",
      alt: "Person presenting UI/UX design concepts on a whiteboard",
    },
    {
      title: "UX research",
      description:
        "We do UX research based on your requirements that help you to gain deep insights into user behaviors and preferences. We follow industry-leading methods to find out valuable insights that help to make strategic design decisions.",
      image: "https://placehold.co/300x200?text=UX+research",
      alt: "Team conducting UX research with sticky notes and diagrams",
    },
    {
      title: "Usability testing",
      description:
        "Ensure your digital products meet user expectations with our rigorous usability testing services. We conduct thorough tests to identify usability issues and optimize user interfaces for seamless interaction.",
      image: "https://placehold.co/300x200?text=Usability+testing",
      alt: "Person conducting usability testing on a digital interface",
    },
    {
      title: "Wireframing and prototyping",
      description:
        "We visualize your ideas and refine user flows with our expert wireframing and prototyping services. We create detailed wireframes and interactive prototypes that align with your vision and user needs.",
      image: "https://placehold.co/300x200?text=Wireframing+and+prototyping",
      alt: "Wireframe sketches and prototype designs on a desk",
    },
    {
      title: "UX Audit",
      description:
        "We help you to explore the full potential of your digital product with our comprehensive UX audit. We identify pain points, usability issues, and areas for improvement, providing actionable insights to enhance user satisfaction and boost conversion rates.",
      image: "https://placehold.co/300x200?text=UX+Audit",
      alt: "Person conducting a UX audit on a digital interface",
    },
    {
      title: "Design system audit",
      description:
        "Ensure consistency and efficiency across your digital assets with our design system audit services. We assess and refine your design components and guidelines to maintain a cohesive brand identity and user experience.",
      image: "https://placehold.co/300x200?text=Design+system+audit",
      alt: "Design system audit with various UI components displayed",
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Expertise in diverse industries",
      content:
        "Benefit from our deep expertise in designing for various industries, ensuring tailored solutions that meet specific sector needs and user expectations.",
      points: [
        "Industry-specific design strategies",
        "Tailored solutions for unique challenges",
        "Understanding of sector-specific user needs",
        "Expertise across multiple market segments",
      ],
    },
    {
      title: "Data-driven approach",
      content:
        "We leverage extensive UX research and analytics to guide our design decisions, ensuring every interface is optimized for usability and effectiveness.",
      points: [
        "UX research informs design decisions",
        "Analytics guide interface optimization",
        "Data-backed user experience improvements",
        "Focus on measurable outcomes",
      ],
    },
    {
      title: "Collaborative design process",
      content:
        "Engage in a collaborative design journey where your feedback and vision are integral. We iterate closely with you to achieve designs that exceed expectations.",
      points: [
        "Client involvement at every stage",
        "Iterative design based on feedback",
        "Transparent communication and updates",
        "Designs aligned with your vision",
      ],
    },
  ];

  const expertiseData = [
    { title: "Data Visualization", content: "Content for Data Visualization" },
    {
      title: "Information Architecture Design",
      content: "Content for Information Architecture Design",
    },
    { title: "Data-Driven Design", content: "Content for Data-Driven Design" },
    { title: "Design Sprint", content: "Content for Design Sprint" },
    { title: "Interaction Design", content: "Content for Interaction Design" },
    { title: "Visual Design", content: "Content for Visual Design" },
    {
      title: "UX Writing and Content Strategy",
      content: "Content for UX Writing and Content Strategy",
    },
    { title: "UI/UX Design", content: "Content for UI/UX Design" },
    {
      title: "User Interface Design",
      content: "Content for User Interface Design",
    },
  ];
  const industries = [
    {
      name: "Enterprise",
      description: "Enterprise solutions description",
      bgImage: "https://placehold.co/600x400?text=Enterprise",
    },
    {
      name: "Fintech",
      description: "Fintech solutions description",
      bgImage: "https://placehold.co/600x400?text=Fintech",
    },
    {
      name: "Healthcare",
      description: "Healthcare solutions description",
      bgImage: "https://placehold.co/600x400?text=Healthcare",
    },
    {
      name: "E-Commerce",
      description: "E-Commerce solutions description",
      bgImage: "https://placehold.co/600x400?text=E-Commerce",
    },
    {
      name: "Edtech",
      description: "Edtech solutions description",
      bgImage: "https://placehold.co/600x400?text=Edtech",
    },
    {
      name: "Corporate",
      description: "Corporate solutions description",
      bgImage: "https://placehold.co/600x400?text=Corporate",
    },
  ];

  const testimonials = [
    {
      text: "Partnering with Musmeind Studio was a good decision for Abayan Capital. They understood the unique challenges of our platform, creating a design that not only aligns with Sharia Law but also makes our users more engaged.",
      name: "Ibrahim Alzkeri",
      title: "Product Manager at Abayan Capital",
      img: "https://placehold.co/50x50",
      alt: "Photo of Ibrahim Alzkeri",
    },
    {
      text: "Musemind completed the project on time and was highly responsive throughout the partnership. Their work was outstanding.",
      name: "Robin Fish",
      title: "Founder, Arrive",
      img: "https://placehold.co/50x50",
      alt: "Photo of Robin Fish",
    },
    {
      text: "They gave us a great solution for the one-tap checkout process. Musemind's attention to detail and ability to address our concerns was impressive. Also communicated well, especially considering the differences in Arabic.",
      name: "Omar Aly",
      title: "Head of Design at Tamara",
      img: "https://placehold.co/50x50",
      alt: "Photo of Omar Aly",
    },
    {
      text: "The team's expertise was very helpful in providing a range of options. They were efficient, timely, and good at project management using Asana and Trello. Their creativity and market knowledge stood out.",
      name: "William Lowe",
      title: "CEO, Panther",
      img: "https://placehold.co/50x50",
      alt: "Photo of William Lowe",
    },
  ];

  const faqData = [
    {
      question: "What are the services of UI/UX design?",
      answer:
        "UI/UX design services include user research, wireframing, prototyping, and visual design.",
    },
    {
      question: "How much do UI/UX design companies charge?",
      answer:
        "The cost varies depending on the scope of the project, but it can range from $5,000 to $50,000.",
    },
    {
      question: "Why do companies hire UI/UX designers?",
      answer:
        "Companies hire UI/UX designers to improve user satisfaction, increase engagement, and drive conversions.",
    },
    {
      question: "How to choose the best UI/UX design company?",
      answer:
        "Look for a company with a strong portfolio, good client reviews, and a clear design process.",
    },
    {
      question: "Why should you hire an agency for UI/UX design?",
      answer:
        "Agencies bring expertise, experience, and a fresh perspective to your project.",
    },
    {
      question: "Should you invest in professional UI/UX design services?",
      answer:
        "Yes, investing in professional UI/UX design services can lead to a better user experience and higher ROI.",
    },
  ];

  const [currentIndex, setCurrentIndex] = React.useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const nextSlide = () => {
    setCurrentSlide((currentSlide + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((currentSlide - 1 + slides.length) % slides.length);
  };
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
    setOpenIndex(openIndex === index ? null : index);
  };
  const [selectedIndustry, setSelectedIndustry] = useState(null);

  const FAQItem = ({ question, answer, isOpen, onClick }) => (
    <div className="border-b py-4">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={onClick}
      >
        <span className="text-lg">{question}</span>
        <i className={`fas fa-chevron-${isOpen ? "up" : "down"}`}></i>
      </div>
      {isOpen && <p className="mt-2 text-gray-600">{answer}</p>}
    </div>
  );
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="mt-3 mb-2">
      <section className="flex flex-col items-start justify-center mt-10 px-3 py-16">
        <h1 className="text-5xl font-bold mb-2" data-aos="fade-right">
          UI & UX Design and Consulting Services
        </h1>
        <p className="text-lg mb-8 max-w-lg" data-aos="fade-left">
          Transform your digital experience with innovative UI & UX design. Our
          expert team creates user-friendly, visually appealing, and
          high-performance web and mobile user interfaces. From concept to
          launch, we ensure a process that enhances user engagement,
          satisfaction, and business growth.
        </p>
        <button className="bg-yellow-400 text-black font-bold py-2 px-4 rounded" data-aos="fade-right">
          Schedule a Call Now
        </button>
        </section>
        <section className="bg-gray-100 py-10">
        <div className="text-center mb-auto">
            <h2 className="text-lg font-bold">TRUSTED BY 200+ GLOBAL BRANDS</h2>
        </div>
        <div className="marquee">
            <img src="https://placehold.co/100x50" alt="i-payout logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Nuport logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Flaunte logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Microsoft logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="The Motley Fool logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Packt logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Indeed logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="daXtra logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="On Deck logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Peel logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Recharge logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Abyan Capital logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Wokelo.ai logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="eAssist logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Divine Home logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Panther logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Helpful logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="CIS logo" className="mx-4"/>
            <img src="https://placehold.co/100x50" alt="Lingxing logo" className="mx-4"/>
        </div>
    </section>
      <div className="flex flex-col mb-0 w-full bg-black text-white h-screen justify-center items-center">
        <div className="grid grid-cols-2 gap-16 px-8">
          <div className="text-lg leading-relaxed">
            <p>
              Shape your ideas into captivating visuals with Musemind. Our
              designs don’t just look good—they work hard. Experience intuitive,
              user-focused design that turns visitors into loyal customers.
              Let’s create a digital experience that speaks to your audience.
            </p>
          </div>
          <div className="text-lg leading-relaxed">
            <p>
              At Orgatro IT, we believe that great design is more than just
              aesthetics—it’s about creating experiences that speak with your
              audience. Our team of expert UI/UX designers focuses on
              understanding your brand, your goals, and your users. We craft
              interfaces that are not only visually stunning but also intuitive
              and easy to navigate, ensuring your visitors have a seamless
              experience from start to finish.
            </p>
            <p>
              We specialize in user-centered design, where every element is
              strategically placed to guide the user journey, enhance
              engagement, and drive conversions. Whether you’re launching a new
              product or revamping an existing platform, Musemind’s design
              solutions are tailored to meet your specific needs. Let us help
              you build a digital presence that truly reflects the essence of
              your brand and keeps your audience coming back for more.
            </p>
          </div>
        </div>
      </div>
      <div className="p-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-black">
            Our comprehensive UI UX design process
          </h1>
          <p className="text-lg text-gray-700 mt-4">
            Our comprehensive UI/UX design process begins with in-depth research
            and analysis, followed by wireframing and prototyping. We refine
            every detail through user testing and feedback, ensuring the final
            product is visually compelling, intuitive, and fully aligned with
            your goals.
          </p>
          <button className="mt-6 px-6 py-3 bg-yellow-400 text-black font-bold rounded-full hover:bg-yellow-500">
            Schedule a Call Now
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-bold text-gray-800 mb-4">
              Discovery & Research
            </h2>
            <p className="text-gray-700 mb-4">
              We dive deep into understanding your business, audience, and
              industry. We gather insights to craft a design strategy that
              aligns with your goals.
            </p>
            <ul className="list-disc list-inside text-gray-700">
              <li>User research</li>
              <li>Market analysis</li>
              <li>Competitor benchmarking</li>
              <li>Stakeholder interviews</li>
              <li>User personas</li>
            </ul>
          </div>
          <div className="bg-yellow-100 p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-bold text-gray-800 mb-4">
              Wireframing & Prototyping
            </h2>
            <p className="text-gray-700 mb-4">
              We create blueprints of your design, mapping out user flows and
              interface elements to ensure a seamless experience.
            </p>
            <ul className="list-disc list-inside text-gray-700">
              <li>User journey mapping</li>
              <li>Interactive prototypes</li>
              <li>Usability testing</li>
              <li>Feedback integration</li>
            </ul>
          </div>
          <div className="bg-red-100 p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Design</h2>
            <p className="text-gray-700 mb-4">
              We bring your brand to life with visually compelling designs that
              engage and captivate your audience.
            </p>
            <ul className="list-disc list-inside text-gray-700">
              <li>Brand integration</li>
              <li>Typography and color selection</li>
              <li>High-fidelity mockups</li>
              <li>Design system creation</li>
              <li>Visual consistency</li>
            </ul>
          </div>
          <div className="bg-teal-100 p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Evaluate</h2>
            <p className="text-gray-700 mb-4">
              We rigorously test and refine the design, ensuring it meets user
              expectations and achieves your business objectives.
            </p>
            <ul className="list-disc list-inside text-gray-700">
              <li>Usability testing</li>
              <li>A/B testing</li>
              <li>User feedback loops</li>
              <li>Iterative design improvements</li>
              <li>Final design validation</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center min-h-screen bg-black text-white">
        <div className="max-w-5xl p-8">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2">
              <h1 className="text-6xl font-bold">Featured</h1>
              <h2 className="text-6xl font-bold text-gray-500">Case Study</h2>
              <h3 className="text-2xl font-bold mt-4">
                Complete Revamp of AI Powered Recruitment solutions
              </h3>
              <p className="mt-4 text-gray-400">
                Daxtra was struggling with several UX/UI challenges, which
                hindered its competitiveness in the AI market.
              </p>
              <p className="mt-2 text-gray-400">
                Following extensive competitor research and a thorough UX
                evaluation, we completely redesigned their recruitment
                application.
              </p>
              <p className="mt-2 text-gray-400">
                The new design features seamless navigation, clear information
                hierarchy, and enhanced data density, providing Gen-Z
                Recruitment with a highly efficient and intuitive user
                experience.
              </p>
              <button className="mt-4 bg-yellow-400 text-black font-bold py-2 px-4 rounded-full">
                Check full case study
              </button>
              <div className="flex mt-8">
                <div className="mr-8">
                  <h4 className="text-4xl font-bold">95%</h4>
                  <p className="text-gray-400">
                    Satisfaction rate achieved during user tests
                  </p>
                </div>
                <div>
                  <h4 className="text-4xl font-bold">$25M</h4>
                  <p className="text-gray-400">Yearly Revenue</p>
                </div>
              </div>
            </div>
            <div className="md:w-1/2 mt-8 md:mt-0 md:ml-8">
              <img
                src="https://placehold.co/600x400"
                alt="Tablet displaying Daxtra recruitment application"
                className="rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 py-8 flex flex-col justify-center items-center">
        <h1 className="text-3xl font-bold text-center mb-8">
          Our on-demand UI/UX services
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8  ">
          {services.map((service, index) => (
            <div key={index} className="text-center">
              <img
                src={service.image}
                alt={service.alt}
                className="w-full h-48 object-cover mb-4"
              />
              <h2 className="text-xl font-bold mb-2">{service.title}</h2>
              <p className="text-gray-700">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="text-center py-10 bg-black flex flex-col justify-center items-center">
        <h1 className="text-2xl font-bold mb-8">
          Our UI/UX Design Success Stories
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 md:px-20  w-10/20">
          <div className="bg-yellow-400 p-8">
            <h2 className="text-4xl font-bold">25k</h2>
            <p className="mt-2">
              We helped Raisethon achieve unique donors by improving its user
              experience!
            </p>
          </div>
          <div className="bg-white text-black p-8">
            <h2 className="text-4xl font-bold">52%</h2>
            <p className="mt-2">Increased donation and it's on the rise!</p>
          </div>
          <div className="bg-green-400 p-8">
            <h2 className="text-4xl font-bold">+300%</h2>
            <p className="mt-2">Campaigns with the utmost success rate!</p>
          </div>
          <div className="bg-white text-black p-8 flex items-center min-w-full0">
            <div>
              <h2 className="text-xl font-bold">RaiseThon</h2>
              <p className="mt-2">
                Raisethon - a fundraising experience like no other!
              </p>
              <button className="mt-4 bg-yellow-400 text-black py-2 px-4 rounded ">
                See Raisethon case study!
              </button>
            </div>
            <img
              src="https://placehold.co/150x150"
              alt="Screenshot of Raisethon app showing fundraising statistics"
              className="ml-4"
            />
          </div>
        </div>
      </div>

      <div className="p-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">
            Benefits of Our UI UX design services
          </h1>
          <p className="text-lg mb-6">
            Choosing our UI/UX design services means partnering with experts
            dedicated to delivering exceptional user experiences. We focus on
            creating intuitive, visually appealing interfaces that drive
            engagement, increase conversions, and elevate your brand. Experience
            design excellence that truly impacts your business.
          </p>
          <button className="bg-yellow-400 text-black font-bold py-2 px-4 rounded-full">
            Schedule a Call Now
          </button>
        </div>
        <div className="mt-12 overflow-hidden">
          <div
            className="flex transition-transform duration-500"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {slides.map((slide, index) => (
              <div key={index} className="min-w-full md:min-w-1/3 p-6">
                <div className="bg-gray-100 p-6 rounded-lg shadow-md">
                  <h2 className="text-xl font-semibold mb-4">{slide.title}</h2>
                  <p className="mb-4">{slide.content}</p>
                  <ul className="list-disc list-inside">
                    {slide.points.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-center mt-8">
          <button
            onClick={prevSlide}
            className="bg-black text-white p-2 rounded-full mx-2"
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          <button
            onClick={nextSlide}
            className="bg-black text-white p-2 rounded-full mx-2"
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>

      <div  className="max-w-full mx-auto p-8 bg-black text-white">
        <div className="grid grid-cols-2 gap-8">
          <div>
            <h1 className="text-3xl font-bold mb-4">Our UI UX design expertise</h1>
            <p className="mb-8">
              Our UI/UX design expertise is grounded in creating user-focused
              experiences that work effectively across various platforms. We
              combine innovative design with strategic insights, ensuring each
              interface is visually engaging and highly functional. Whether web
              or mobile, our designs are tailored to achieve your objectives.
            </p>
            <img
              src="https://placehold.co/600x400"
              alt="Person working on a laptop with code on the screen and a plant in the background"
              className="rounded-lg"
            />
          </div>
          <div>
            <ul className="space-y-4">
              {expertiseData.map((item, index) => (
                <li key={index} className="bg-gray-800 rounded-lg">
                  <div
                    className="flex justify-between items-center p-4 cursor-pointer"
                    onClick={() => handleClick(index)}
                  >
                    <span>{item.title}</span>
                    <i
                      className={`fas fa-chevron-${
                        activeIndex === index ? "up" : "down"
                      }`}
                    ></i>
                  </div>
                  {activeIndex === index && (
                    <div className="p-4 bg-gray-700 rounded-b-lg">
                      {item.content}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center min-h-screen p-4">
        <div className="text-center mb-8">
          <h1 className="text-2xl md:text-4xl font-bold text-black mb-4">
            Our Expertise in UI/UX Design Service Across Industries
          </h1>
          <p className="text-base md:text-lg text-black mb-6">
            We’ve worked with dozens of app businesses across industries to
            launch groundbreaking MVPs. Here are some industries where we excel,
            but our expertise extends far beyond:
          </p>
          <button className="bg-yellow-400 text-black font-bold py-2 px-4 rounded-full hover:bg-yellow-500">
            Schedule a Call Now
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="bg-white p-6 border border-gray-200 flex flex-col items-center justify-between cursor-pointer"
              onClick={() => setSelectedIndustry(industry)}
            >
              <h2 className="text-xl font-semibold mb-4">{industry.name}</h2>
              <div className="text-2xl">
                <i
                  className={`fas fa-arrow-right ${
                    industry.name === "Edtech" ? "text-yellow-400" : ""
                  }`}
                ></i>
              </div>
            </div>
          ))}
        </div>
        {selectedIndustry && (
          <div
            className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center p-4"
            onClick={() => setSelectedIndustry(null)}
          >
            <div
              className="bg-white p-8 rounded-lg shadow-lg transform transition-transform duration-300 max-w-lg w-full"
              style={{
                backgroundImage: `url(${selectedIndustry.bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <h2 className="text-3xl font-bold mb-4">
                {selectedIndustry.name}
              </h2>
              <p className="text-lg mb-4">{selectedIndustry.description}</p>
              <button className="bg-yellow-400 text-black font-bold py-2 px-4 rounded-full hover:bg-yellow-500">
                Close
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 py-12">
        <h1 className="md:text-4xl text-1xl font-bold mb-12 text-center text-gray-800 text-wrap">
          Why is Orgatro IT the best UI UX Design service provider?
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-6xl px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <i className="fas fa-industry text-4xl text-blue-500 mb-4"></i>
            <h2 className="text-xl font-bold mb-2 text-gray-800">
              Industry Expertise
            </h2>
            <p className="text-gray-600">
              We bring extensive experience across various industries,
              delivering tailored design solutions that meet specific sector
              needs.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <i className="fas fa-chart-line text-4xl text-green-500 mb-4"></i>
            <h2 className="text-xl font-bold mb-2 text-gray-800">
              Data-Driven Approach
            </h2>
            <p className="text-gray-600">
              Our designs are guided by data and user insights, ensuring optimal
              usability and impactful user experiences.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <i className="fas fa-handshake text-4xl text-purple-500 mb-4"></i>
            <h2 className="text-xl font-bold mb-2 text-gray-800">
              Collaborative Process
            </h2>
            <p className="text-gray-600">
              We work closely with you throughout the design journey,
              incorporating your feedback to create designs that align with your
              vision.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <i className="fas fa-mobile-alt text-4xl text-red-500 mb-4"></i>
            <h2 className="text-xl font-bold mb-2 text-gray-800">
              Responsive and Mobile-Friendly
            </h2>
            <p className="text-gray-600">
              Our designs are optimized for all devices, ensuring seamless user
              experiences across desktops, tablets, and smartphones.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <i className="fas fa-expand-arrows-alt text-4xl text-yellow-500 mb-4"></i>
            <h2 className="text-xl font-bold mb-2 text-gray-800">
              Scalability and Future-Proofing
            </h2>
            <p className="text-gray-600">
              We create designs that grow with your business, ensuring they
              remain relevant and effective as your needs evolve.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <i className="fas fa-headset text-4xl text-teal-500 mb-4"></i>
            <h2 className="text-xl font-bold mb-2 text-gray-800">
              After-Service Support
            </h2>
            <p className="text-gray-600">
              We provide ongoing support, helping you maintain and optimize your
              digital products long after the initial launch.
            </p>
          </div>
        </div>
      </div>
      <div className="container mx-auto py-12 w-1/2">
        <div className="text-center mb-8">
          <div className="inline-block bg-green-500 text-white px-3 py-1 rounded-full mb-2">
            200+ Trusted Clients
          </div>
          <h1 className="text-3xl font-bold">
            Get the real story, not just our words!
          </h1>
        </div>
        <div className="relative flex justify-center">
          <div className="bg-white p-6 rounded-lg shadow-lg w-80">
            <div className="text-4xl text-gray-400 mb-4">“</div>
            <p className="text-gray-700 mb-4">
              {testimonials[currentIndex].text}
            </p>
            <div className="flex items-center">
              <img
                className="w-12 h-12 rounded-full mr-4"
                src={testimonials[currentIndex].img}
                alt={testimonials[currentIndex].alt}
              />
              <div>
                <p className="font-bold">{testimonials[currentIndex].name}</p>
                <p className="text-gray-500">
                  {testimonials[currentIndex].title}
                </p>
              </div>
            </div>
          </div>
          <div
            className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-yellow-400 p-2 rounded-full cursor-pointer"
            onClick={handlePrev}
          >
            <i className="fas fa-arrow-left"></i>
          </div>
          <div
            className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-yellow-400 p-2 rounded-full cursor-pointer"
            onClick={handleNext}
          >
            <i className="fas fa-arrow-right"></i>
          </div>
        </div>
      </div>
      <div className="container mx-auto text-center md:w-1/3">
        <h1 className="text-4xl font-bold mb-8">Frequently Asked Question</h1>
        <div className="bg-white shadow-md rounded-lg p-6 space-y-4">
          {faqData.map((item, index) => (
            <FAQItem
              key={index}
              question={item.question}
              answer={item.answer}
              isOpen={openIndex === index}
              onClick={() => handleClick(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
